import sha256 from 'crypto-js/sha256';

const environment = {
    localhost: {
        API_URL                       : 'http://localhost:65000',
        ATTACHMENTS_URL               : '',
        ENV                           : 'dev',
        FORCE_MFA_TOTP                : true,
        MFA_ISSUER                    : 'Dev - Viarium Back Office',
        CHECK_REFRESH_TOKEN           : 60000,
        REFRESH_TOKEN_INTERVAL        : 1680000,
        DEFAULT_TIMEOUT_POPUPS        : 5000,
        DAY_IN_SECONDS                : 86400,
        HOME_PAGE                     : '/panels',
        REACT_APP_USERPOOL_ID         : 'eu-west-3_8HZub2YrD',
        REACT_APP_CLIENT_ID           : '59ajrnc6r7dlettj59ufddiq1s',
        MUI_DATA_GRID_PREMIUM_LICENSE : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
        GOOGLE_MAPS_API               : 'AIzaSyBYYkRLH6y_rzlVl8y6uHhBqgiwycdbX_0',
        DEFAULT_MAP_ZOOM              : 12,
        AVAILABLE_CITIES              : [{"id":"it-rom", "label": "Roma"}, {"id": "it-fir", "label": "Firenze" }],
        MAP_COORDS                    : { "it-rom": { lat: 41.89028205258936, lng: 12.492230896867742 }, "it-fir": { lat: 43.77317113734545, lng: 11.255954979250285 }}
    },
    dev: {
        API_URL                       : `https://viarium.igpdecaux.it/${sha256('viarium-backoffice-dev')}`,
        ATTACHMENTS_URL               : '',
        ENV                           : 'dev',
        FORCE_MFA_TOTP                : true,
        MFA_ISSUER                    : 'Dev - Viarium Back Office',
        CHECK_REFRESH_TOKEN           : 60000,
        REFRESH_TOKEN_INTERVAL        : 1680000,
        DEFAULT_TIMEOUT_POPUPS        : 5000,
        DAY_IN_SECONDS                : 86400,
        HOME_PAGE                     : '/panels',
        REACT_APP_USERPOOL_ID         : 'eu-west-3_8HZub2YrD',
        REACT_APP_CLIENT_ID           : '59ajrnc6r7dlettj59ufddiq1s',
        MUI_DATA_GRID_PREMIUM_LICENSE : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
        GOOGLE_MAPS_API               : 'AIzaSyBYYkRLH6y_rzlVl8y6uHhBqgiwycdbX_0',
        DEFAULT_MAP_ZOOM              : 12,
        AVAILABLE_CITIES              : [{"id":"it-rom", "label": "Roma"}, {"id": "it-fir", "label": "Firenze" }],
        MAP_COORDS                    : { "it-rom": { lat: 41.89028205258936, lng: 12.492230896867742 }, "it-fir": { lat: 43.77317113734545, lng: 11.255954979250285 }}
    },
    test: {
        API_URL                       : `https://viarium.igpdecaux.it/${sha256('viarium-backoffice-test')}`,
        ATTACHMENTS_URL               : '',
        ENV                           : 'test',
        FORCE_MFA_TOTP                : true,
        MFA_ISSUER                    : 'Test - Viarium Back Office',
        CHECK_REFRESH_TOKEN           : 60000,
        REFRESH_TOKEN_INTERVAL        : 1680000,
        DEFAULT_TIMEOUT_POPUPS        : 5000,
        DAY_IN_SECONDS                : 86400,
        HOME_PAGE                     : '/panels',
        REACT_APP_USERPOOL_ID         : 'eu-west-3_C9ImXKqz3',
        REACT_APP_CLIENT_ID           : '27js9dbho7lrkr6gn353c7rn45',
        MUI_DATA_GRID_PREMIUM_LICENSE : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
        GOOGLE_MAPS_API               : 'AIzaSyBYYkRLH6y_rzlVl8y6uHhBqgiwycdbX_0',
        DEFAULT_MAP_ZOOM              : 12,
        AVAILABLE_CITIES              : [{"id":"it-rom", "label": "Roma"}, {"id": "it-fir", "label": "Firenze" }],
        MAP_COORDS                    : { "it-rom": { lat: 41.89028205258936, lng: 12.492230896867742 }, "it-fir": { lat: 43.77317113734545, lng: 11.255954979250285 }}
    },
    prod: {
        API_URL                       : `https://viarium.igpdecaux.it/${sha256('viarium-backoffice-prod')}`,
        ATTACHMENTS_URL               : '',
        ENV                           : 'prod',
        FORCE_MFA_TOTP                : true,
        MFA_ISSUER                    : 'Viarium Back Office',
        CHECK_REFRESH_TOKEN           : 60000,
        REFRESH_TOKEN_INTERVAL        : 1680000,
        DEFAULT_TIMEOUT_POPUPS        : 5000,
        DAY_IN_SECONDS                : 86400,
        HOME_PAGE                     : '/panels',
        REACT_APP_USERPOOL_ID         : 'eu-west-3_mVxFYrnOV',
        REACT_APP_CLIENT_ID           : '7noqpne131ija5rcnrngbk7551',
        MUI_DATA_GRID_PREMIUM_LICENSE : '1660a90a023caa892e9621f16cfa2e33Tz0xMjAzNzMsRT0xNzk0MDk1OTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y',
        GOOGLE_MAPS_API               : 'AIzaSyBYYkRLH6y_rzlVl8y6uHhBqgiwycdbX_0',
        DEFAULT_MAP_ZOOM              : 12,
        AVAILABLE_CITIES              : [{"id":"it-rom", "label": "Roma"}, {"id": "it-fir", "label": "Firenze" }],
        MAP_COORDS                    : { "it-rom": { lat: 41.89028205258936, lng: 12.492230896867742 }, "it-fir": { lat: 43.77317113734545, lng: 11.255954979250285 }}
    }
}

export default environment[process.env.REACT_APP_ENV || 'localhost'];